import { getStream, getStreamParams, getItems, hasMore, } from '../base/selectors';
var DEFAULT_ITEMS_COUNT_PER_PAGE = 10;
function getPaginatedStream(state, streamId) {
    return getStream(state, streamId);
}
export var getItemsPerPage = function (state, streamId) {
    var streamParams = getStreamParams(state, streamId);
    if (streamParams && streamParams.itemsPerPage) {
        return streamParams.itemsPerPage;
    }
    return DEFAULT_ITEMS_COUNT_PER_PAGE;
};
export var getCurrentPage = function (state, streamId) {
    return getPaginatedStream(state, streamId).page || 0;
};
export var hasPreviousPage = function (state, streamId) {
    return getCurrentPage(state, streamId) > 0;
};
export var hasNextPage = function (state, streamId) {
    var itemsPerPage = getItemsPerPage(state, streamId);
    var items = getItems(state, streamId);
    var currentPage = getCurrentPage(state, streamId);
    return ((currentPage + 1) * itemsPerPage < items.length || hasMore(state, streamId));
};
export var getNextOffset = function (state, streamId) {
    var currentPage = getCurrentPage(state, streamId);
    var itemsPerPage = getItemsPerPage(state, streamId);
    return currentPage * itemsPerPage;
};
export var getCurrentPageItems = function (state, streamId) {
    var currentPage = getCurrentPage(state, streamId);
    var items = getItems(state, streamId);
    var itemsPerPage = getItemsPerPage(state, streamId);
    var currentPageItems = items.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);
    return currentPageItems;
};
//# sourceMappingURL=selectors.js.map